import { Container } from 'react-bootstrap'
import {
  Routes,
  Route,
  useNavigate,
} from 'react-router-dom'
import pageArray from '../../pages'
import { PrivateRoute } from 'components'
import { useSelector } from 'react-redux'
import { IRootState } from 'types'
import { MenuRouteDto } from '@v1UsersApi'
import { useEffect } from 'react'

const Router = () => {
  const navigate = useNavigate()

  const authenticated = useSelector((state: IRootState) => state.user.authenticated)
  const appLoaded = useSelector((state: IRootState) => state.app.loaded)
  const multiFactorLoginEnabled = useSelector((state: IRootState) => state.user.multiFactorLoginEnabled)
  const multiFactorConfirmed = useSelector((state: IRootState) => state.user.multiFactorConfirmed)
  const routes = useSelector((state: IRootState) => state.app.routes)

  const findPageComponent = (componentName: string | undefined) => { return pageArray.find(p => p.name == componentName)?.component }

  if (multiFactorLoginEnabled && !multiFactorConfirmed && !location.pathname.startsWith(process.env.REACT_APP_2FA_REDIRECT!)) {
    navigate(process.env.REACT_APP_2FA_REDIRECT!)
    return (<></>)
  }


  const ExternalRedirect = ({ url }: { url: string }) => {
    useEffect(() => {
      window.location.href = url
    }, [url])

    return null
  }

  if (!appLoaded) {
    return (<></>)
  }

  if (!authenticated || !routes || routes.length === 0) {
    return (
      <Container fluid className='mt-3'>
        <Routes>
          <Route
            path='*'
            element={<PrivateRoute component={findPageComponent('LoginPage')} title='Login' />}
          />
        </Routes>
      </Container>
    )
  }

  return (
    <Container fluid className='mt-3'>
      <Routes>
        {routes && routes.map((item: MenuRouteDto, idx) => (
          <Route
            path={item.route}
            key={idx}
            element={
              <PrivateRoute
                component={findPageComponent(item.componentName)}
                title={item.title}
              />
            } />
        ))}

        <Route
          path={process.env.REACT_APP_LOGIN_REDIRECT}
          element={
            <PrivateRoute
              component={findPageComponent('LoginPage')}
              title='Login'
            />
          }
        />
        {process.env.REACT_APP_ENABLE_OLD_SA_INTEGRATION === 'true' ?
          <Route
            path='/'
            element={
              <ExternalRedirect url={`${process.env.REACT_APP_OLD_SYS_ADMIN_URL}/web/Home.aspx`} />
            }
          />
          : <Route
            path='/'
            element={
              <div>Home page</div>
            }
          />
        }

        <Route
          path='*'
          element={
            <PrivateRoute
              component={findPageComponent('NotFoundPage')}
              title='Page Not Found'
            />
          }
        />
      </Routes>
    </Container>
  )
}

export default Router
